import React from 'react'
// import { Link } from 'gatsby'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faAngleDown } from '@fortawesome/free-solid-svg-icons'
import styled from 'styled-components'
import NavLink from './nav-link'

const NavWrapper = styled.div`
  text-transform: Uppercase;
  letter-spacing: 0.125em;
  font-size: 0.9em;
  line-height: 1em;

  button {
    text-transform: Uppercase;
    letter-spacing: 0.125em;
    ${'' /* font-size: 0.9em; */}
    line-height: 1em;
  }
  div.grid-wrapper {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(160px, 1fr));
    /* grid-template-columns: 1fr 1fr 1fr 1fr 1fr 1fr; */
  }

  .item,
  .item button {
    justify-items: center;
    align-items: center;
    justify-content: center;
    align-content: center;
  }
`

const Navigation = () => (
  <nav className="w3-row">
    <NavWrapper className="w3-main-navigation">
      <div
        className="grid-wrapper"
        style={{ margin: 'var(--center)', maxWidth: 'var(--width)' }}
      >
        <div className="w3-dropdown-hover w3-mobile ">
          <NavLink to="/permanent-makeup/" className="item">
            <button type="button" className="w3-button">
              Permanent Makeup
              {/* <FontAwesomeIcon icon={faAngleDown} /> */}
            </button>
          </NavLink>
          <div className="w3-dropdown-content w3-bar-block w3-card-4 ">
            <NavLink
              to="/permanent-makeup-eyebrows/"
              className="w3-bar-item w3-button w3-mobile"
            >
              Eyebrows
            </NavLink>
            <NavLink
              to="/permanent-makeup-lips/"
              className="w3-bar-item w3-button w3-mobile"
            >
              Lips
            </NavLink>
            <NavLink
              to="/permanent-makeup-eyeliner/"
              className="w3-bar-item w3-button w3-mobile"
            >
              Eyeliner
            </NavLink>

            <NavLink
              to="/permanent-makeup-removal/"
              className="w3-bar-item w3-button w3-mobile"
            >
              Permanent Makeup Removal
            </NavLink>
          </div>
        </div>

        <div className="w3-dropdown-hover w3-mobile ">
          <NavLink to="/permanent-makeup-process/" className="item">
            <button type="button" className="w3-button">
              The Process
            </button>
          </NavLink>
          <div className="w3-dropdown-content w3-bar-block w3-card-4 ">
            <NavLink to="/faq/" className="w3-bar-item w3-button w3-mobile">
              FAQ
            </NavLink>
            <NavLink to="/what-is-cosmetic-tattoo-touch-up-really-all-about/" className="w3-bar-item w3-button w3-mobile">
              Touch Up
            </NavLink>
            <NavLink to="/consultation/" className="w3-bar-item w3-button w3-mobile">
              Consultation
            </NavLink>
            <NavLink to="/medical-considerations-before-permanent-makeup/" className="w3-bar-item w3-button w3-mobile">
              Medical Considerations
            </NavLink>
          </div>
        </div>

        <div className="w3-dropdown-hover w3-mobile ">
          <NavLink to="/portfolio/" className="item">
            <button type="button" className="w3-button">
              Portfolio
              {/* <FontAwesomeIcon icon={faAngleDown} /> */}
            </button>
          </NavLink>

          {/* <div className="w3-dropdown-content w3-bar-block w3-card-4">
            <NavLink
              to="/before-and-after-permanent-eyebrows/"
              className="w3-bar-item w3-button w3-mobile"
            >
              Eyebrows
            </NavLink>
            <NavLink
              to="/before-and-after-permanent-lips/"
              className="w3-bar-item w3-button w3-mobile"
            >
              Lips
            </NavLink>
            <NavLink
              to="/before-and-after-permanent-eyeliner/"
              className="w3-bar-item w3-button w3-mobile"
            >
              Eyeliner
            </NavLink>
          </div> */}
        </div>

        <NavLink to="/blog/" className="item">
          <button type="button" className="w3-button">
            Blog
          </button>
        </NavLink>
        {/* <NavLink to="/pricing/" className="item">
          <button type="button" className="w3-button">
            Pricing
          </button>
        </NavLink> */}

        <a className="item"
                          rel="noopener noreferrer nofollow"
                          target="_blank"
                          href={"https://square.site/book/3Q13NMMB2RG0E/longmakeup-permanent-makeup-nyc-new-york-ny"}
                        >
                          <button type="button" className="w3-button">
                          Online Booking
                          </button>
                        </a>

        {/* <NavLink to="" className="item" >
          <button type="button" className="w3-button">
            Online Booking
          </button>
        </NavLink> */}
        <NavLink to="/contact/" className="item">
          <button type="button" className="w3-button">
            Contact
          </button>
        </NavLink>
      </div>
    </NavWrapper>
  </nav>
)

export default Navigation
//TODO: store add hours to contact from backend
